<script setup lang="ts">
const props = defineProps<{
  block: any;
  pageIndex: number;
  blockIndex: number;
}>();

const emit = defineEmits<{
  update: [data: any];
  contentEdit: [];
}>();

function updateTitle(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { title: target.innerText });
  emit("contentEdit");
}

function updateColumnLabel(colIndex: number, event: Event) {
  const target = event.target as HTMLElement;
  const newColumns = [...props.block.data.columns];
  newColumns[colIndex].label = target.innerText;
  emit("update", { columns: newColumns });
  emit("contentEdit");
}

function updateCell(rowIndex: number, columnKey: string, event: Event) {
  const target = event.target as HTMLInputElement;
  const newData = [...props.block.data.data];
  newData[rowIndex][columnKey] = target.value;
  emit("update", { data: newData });
  emit("contentEdit");
}
</script>

<template>
  <div class="table-block" :style="block.style">
    <h3 contenteditable="true" @blur="updateTitle">{{ block.data.title }}</h3>
    <table class="data-table">
      <thead>
        <tr>
          <th
            v-for="(column, colIndex) in block.data.columns"
            :key="column.key"
            contenteditable="true"
            @blur="updateColumnLabel(colIndex, $event)"
          >
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in block.data.data" :key="rowIndex">
          <td v-for="column in block.data.columns" :key="column.key">
            <span v-if="!column.editable" class="readonly-cell">
              {{ row[column.key] }}
            </span>
            <input
              v-else
              :value="row[column.key]"
              @input="updateCell(rowIndex, column.key, $event)"
              class="editable-cell"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table-block {
  overflow-x: auto;
}

.table-block h3 {
  margin: 0 0 15px 0;
  color: #333;

  &:focus {
    outline: 2px dashed #007bff;
  }
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
}

.data-table th,
.data-table td {
  border: 1px solid #dee2e6;
  padding: 10px;
  text-align: left;
}

.data-table th {
  background: #f8f9fa;
  font-weight: bold;

  &:focus {
    outline: 2px dashed #007bff;
  }
}

.data-table td {
  background: white;
}

.readonly-cell {
  display: block;
  padding: 6px 4px;
}

.editable-cell {
  width: 100%;
  border: 1px dashed #ccc;
  padding: 6px 8px;
  background: transparent;

  &:focus {
    outline: none;
    border-color: #007bff;
    background: #f8f9ff;
  }
}
</style>
